import {Platform, useWindowDimensions} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

import {ITheme} from 'contexts/ThemeContext';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return CreateResponsiveStyle(
    {
      defaultpickerContainerStyle: {
        width: width - 32,
      },
      pickerLabelStyle: {
        marginBottom: 5,
        fontSize: 14,
        lineHeight: 18,
        color: colors.primaryTextColor,
        ...typography.mulishSemibold,
      },
      pickerButtonStyle: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 16,
        width: '100%',
        height: 44,
        backgroundColor: colors.white,
        borderWidth: 1,
        borderRadius: 8,
        borderColor: colors.grey300,
        shadowColor: colors.black,
        shadowOffset: {
          width: 0,
          height: 0.5,
        },
        shadowOpacity: 0.1,
        shadowRadius: 1,

        elevation: 1,
      },
      calendarContainerStyle: {},
      ...Platform.select({
        web: {
          selectedPickerButtonStyle: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingHorizontal: 16,
            width: '100%',
            height: 48,
            backgroundColor: colors.white,
            borderWidth: 1,
            borderRadius: 8,
            borderColor: colors.cornflowerBlue,
          },
          calendarContainerStyle: {
            position: 'absolute',
            top: 50,
            left: 138,
            padding: 10,
            backgroundColor: colors.alabaster,
            borderWidth: 1,
            borderColor: colors.grey300,
            borderRadius: 8,
          },
        },
      }),
      leftSideContainerStyle: {
        flexDirection: 'row',
        alignItems: 'center',
      },
      iconButtonStyle: {
        marginRight: 10,
        width: 22,
        height: 22,
      },
      arrowStyle: {
        width: 10,
        height: 10,
      },
      pickerValueStyle: {
        fontSize: 16,
        color: colors.primaryTextColor,
        ...typography.interRegular,
      },
      flatListStyle: {
        position: 'absolute',
        top: 75,
        left: 0,
        width: width - 32,
        maxHeight: 192,
        backgroundColor: colors.white,
        borderWidth: 1,
        borderColor: colors.grey300,
        borderRadius: 8,
        zIndex: 1,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        defaultpickerContainerStyle: {
          flexDirection: 'row',
          alignItems: 'center',
        },
        pickerLabelStyle: {
          width: 90,
          marginRight: 8,
          marginBottom: 0,
          fontSize: 18,
        },
        pickerButtonStyle: {
          width: 320,
          height: 48,
        },
        selectedPickerButtonStyle: {
          width: 320,
        },
        flatListStyle: {
          width: 321,
          top: 50,
          left: 97,
        },
      },
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {
        pickerButtonStyle: {
          width: 504,
        },
        selectedPickerButtonStyle: {
          width: 504,
        },
        flatListStyle: {
          width: 505,
          left: 137,
        },
        pickerLabelStyle: {
          width: 130,
        },
      },
    },
  )();
};
